export function getTrackedStatusChange(da, seenStatuses = {}) {
  if (!da?.id) return null;
  const hasVisitSnapshot = Object.prototype.hasOwnProperty.call(seenStatuses, da.id);
  const previous = hasVisitSnapshot ? seenStatuses[da.id] : da.last_seen_status;
  if (!previous || !da.status || previous === da.status) return null;
  return {
    ...da,
    changeFrom: previous,
    changeTo: da.status,
  };
}

export function getTrackedStatusChanges(tracked = [], seenStatuses = {}) {
  return tracked
    .map(da => getTrackedStatusChange(da, seenStatuses))
    .filter(Boolean);
}

export function mergeTrackedStatusChangeSnapshot(liveChanges = [], visitSnapshot = [], tracked = []) {
  const trackedById = new Map(tracked.map(da => [da.id, da]));
  const merged = [];

  for (const snapshot of visitSnapshot) {
    const live = trackedById.get(snapshot.id);
    if (!live || live.status !== snapshot.changeTo) continue;
    merged.push({
      ...live,
      changeFrom: snapshot.changeFrom,
      changeTo: snapshot.changeTo,
    });
  }

  const snapIds = new Set(merged.map(change => change.id));
  for (const change of liveChanges) {
    if (!snapIds.has(change.id)) merged.push(change);
  }

  return merged;
}
